import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { signOut } from "../Services/loginService";

const API_BASE_URL = "https://lexington.myhoa.club/api".replace(/\/+$/, "");

const api = axios.create({
  baseURL: API_BASE_URL
});

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");

  if (!refreshToken) {
    throw new Error("No refresh token found");
  }

  const response = await axios.post(`${API_BASE_URL}/refresh-token`, {
    refreshToken
  });

  const newToken = response.data.token;

  localStorage.setItem("authToken", newToken);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  localStorage.setItem("user", JSON.stringify({ ...user, token: newToken }));

  return newToken;
};

api.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem("authToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);

        if (decoded.exp <= currentTime) {
          token = await refreshAccessToken();
        }

        config.headers["Authorization"] = `Bearer ${token}`;
      } catch (error) {
        console.error("Token error:", error);
        signOut();
        throw new axios.Cancel("Invalid or expired session");
      }
    }

    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized — clearing session");
      signOut();
    }

    return Promise.reject(error);
  }
);

export const fetchFolders = () => api.get("/folders");
export const fetchFiles = () => api.get("/files");
export const fetchViolations = () => api.get("/getViolations");
export const fetchGeneralRequests = () => api.get("/getGeneralRequests");
export const fetchArchitecturalRequests = () => api.get("/getArchitecturalRequests");
export const fetchAssignableUsers = () => api.get("/users-by-role");

export const uploadFile = (formData) => api.post("/upload", formData);

export const updateNotice = (id, notice) =>
  api.post(`/updateNotice/${id}`, { notice });

export const fetchNotices = () => api.get("/notices");

export const downloadFile = (filename) =>
  api.get(`/images/${filename}`, { responseType: "blob" });

export const fetchEvents = () => api.get("/getEvents");
export const addEvent = (eventData) => api.post("/addEvent", eventData);
export const editEvent = (id, updatedData) => api.put(`/editEvent/${id}`, updatedData);
export const deleteEvent = (id) => api.delete(`/deleteEvent/${id}`);

export const fetchUsers = () => api.get("/users");

export const fetchTopMembers = () => api.get("/top-members");

export { API_BASE_URL };
export default api;